import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "M4.018 8.383c0-.263-.343-.51-.613-.789-.263-.263-1.96-1.928-2.047-2.063 4.015 0 8.085-.024 12.1 0 .279 0 .534 0 .534-.35 0-.3-.343-.295-.51-.295-4.023.024-8.11 0-12.132 0 .088-.135 2.047-2.055 2.366-2.382.159-.159.287-.223.287-.462a.32.32 0 0 0-.295-.295c-.24 0-.757.605-.932.789L.632 4.679C.4 4.91.274 5.045.25 5.165v.08c.024.119.143.255.366.478l2.577 2.573c.1.1.335.366.486.366a.3.3 0 0 0 .319-.295zM21.136.712a4.3 4.3 0 0 1 2.278.574c.589.343 1.09.818 1.466 1.386l.287.518a4.35 4.35 0 0 1-.597 4.628 4 4 0 0 1-.813.749 3 3 0 0 1-.311.2c-.12.072-.223.118-.353.182a4.36 4.36 0 0 1-4.015-.167l-.167-.1a4.37 4.37 0 0 1-1.991-3.5 4.27 4.27 0 0 1 .566-2.31q.192-.337.446-.629c.048-.056.072-.088.119-.143a4.7 4.7 0 0 1 .7-.613 4.3 4.3 0 0 1 2.382-.789zm4.907 4.533a4.6 4.6 0 0 0-.65-2.613l-.35-.518a4.7 4.7 0 0 0-1.76-1.41 4.84 4.84 0 0 0-4.094 0c-.127.064-.247.119-.366.191a4.76 4.76 0 0 0-1.925 2.111 4.84 4.84 0 0 0 .669 5.138l.426.446c.072.056.088.08.15.135a4.82 4.82 0 0 0 2.95 1.124 4.54 4.54 0 0 0 2.2-.454 4.66 4.66 0 0 0 2.3-2.3c.275-.58.428-1.209.45-1.85Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }